<template>
  <ElCollapseItem class="mtb-20">
    <template #icon="{ isActive }">
      <ElButton class="collapse-btn">
        详情
        <img :class="['icon', { up: isActive, }]" src="../../assets/detail-panel-arrow.svg" />
      </ElButton>

    </template>

    <template #title>
      <ElRow class="title" :gutter="10">
        <ElCol :span="7">
          <div class="name">
            {{ props.name }}
            <span v-if="props.newFlag">新发布</span>
          </div>
        </ElCol>
        <ElCol :span="9">
          <ElTooltip
            placement="top-start"
            :disabled="!locationOverflow"
          >
            <template #content>
              <div class="tooltip-content">{{ props.location }}</div>
            </template>
            <span ref="locationRef" class="ellipsis-multi" @mouseenter="checkOverflow('location')">
              {{ props.location }}
            </span>
          </ElTooltip>
        </ElCol>
        <ElCol :span="8">
          <ElTooltip
            placement="top-start"
            :disabled="!educationOverflow"
          >
            <template #content>
              <div class="tooltip-content">{{ props.educationRequired || '--' }}</div>
            </template>
            <span ref="educationRef" class="ellipsis-multi" @mouseenter="checkOverflow('education')">
              {{ props.educationRequired || '--' }}
            </span>
          </ElTooltip>
        </ElCol>
      </ElRow>
    </template>

    <DetailCollapse
      :text="props.text"
      :name="props.name"
      :id="props.id"
    />
  </ElCollapseItem>

</template>

<script setup lang="ts">
import { defineProps, ref } from 'vue'
import { ElButton, ElCollapseItem, ElRow, ElCol, ElTooltip } from 'element-plus';
import DetailCollapse from "../detail-collapse.vue";

const props = defineProps<{
  name: string,
  location: string,
  date: string,
  text: string,
  newFlag: boolean,
  id: string,
  educationRequired: string | null
}>();

const locationRef = ref<HTMLElement | null>(null);
const educationRef = ref<HTMLElement | null>(null);
const locationOverflow = ref(false);
const educationOverflow = ref(false);

const checkOverflow = (type: 'location' | 'education') => {
  const el = type === 'location' ? locationRef.value : educationRef.value;
  if (!el) return;
  const overflow = el.scrollHeight > el.clientHeight;
  if (type === 'location') {
    locationOverflow.value = overflow;
  } else {
    educationOverflow.value = overflow;
  }
};
</script>

<style>
.title {
  width: 100%;
  text-align: left;
  color: #03050D;
  font-size: 18px;
}
.el-row {
  align-items: center;
}

.collapse-btn {
  width: 72px;
  margin-left: 10px;
  border-color: #7E51E4;
  color: #7E51E4;
  cursor: pointer;
  &:hover {
    background-color: #fff;
    border-color: #9B6FFF;
    color: #9B6FFF;
  }
}

.icon {
  transition: all .2s;
  margin-left: 4px;
  width: 10px
}

.up {
  transform: rotate(180deg);
}
.el-collapse-item__header {
  padding: 30px 0;
}

.name {
  padding: 0 10px;
  span {
    font-size: 14px;
    color: #F33D56;
    border-radius: 20px;
    border: 1px solid #F33D56;
    padding: 2px 8px;
    margin-left: 2px;
  }
}
.ellipsis-multi {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  line-height: 24px;
}
.tooltip-content {
  max-width: 280px;
  word-break: break-all;
  white-space: normal;
}
</style>